import {
  COMPLETION_DIAGNOSTIC,
  COMPLETION_VIDEO,
  sanitizeCompletionRequirements,
} from '@/constants/groups';

/**
 * 그룹 수료 조건과 과정 선택의 오류/경고를 계산한다.
 * - 동영상 강의: 과정 선택 필수
 * - 진단 및 대응훈련: 훈련 필요 과정 선택 필수
 * - 과정만 선택하고 동영상 강의를 빼면 수료증 미발급 경고
 */
export const getGroupCourseRequirementIssues = ({
  requirements,
  courseIds,
  selectedCourses = [],
}) => {
  const reqs = sanitizeCompletionRequirements(requirements);
  const ids = Array.isArray(courseIds) ? courseIds : [];
  const hasVideo = reqs.includes(COMPLETION_VIDEO);
  const hasDiagnostic = reqs.includes(COMPLETION_DIAGNOSTIC);
  const hasTrainingCourse = selectedCourses.some((course) => Boolean(course?.hasTraining));

  const errors = [];
  const warnings = [];

  if (hasVideo && ids.length === 0) {
    errors.push('동영상 강의를 수료 조건으로 선택한 경우 과정을 선택해야 합니다.');
  }

  if (hasDiagnostic && !hasTrainingCourse) {
    errors.push('진단 및 대응훈련을 수료 조건으로 선택한 경우 훈련이 필요한 과정을 선택해야 합니다.');
  }

  if (!hasVideo && ids.length > 0) {
    warnings.push('동영상 강의를 수료 조건에 포함하지 않으면 수료증이 발급되지 않습니다.');
  }

  return { errors, warnings };
};
